import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../hooks'
import { FormFieldSelectNG } from '../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { InputSelect } from '../../../Select'
import { APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE } from '../../RentalPortalApplicant.constants'
import { getMockApplicantHouseholdSizes } from '../../RentalPortalApplicant.mocks'
import { toApplicantHouseholdSizeSelectItems } from '../../RentalPortalApplicant.utils'

function HouseholdSizeField({ fieldRef }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={InputSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t(
              'RentalPortal.ApplicantFormHouseholdSizePlaceholderKey'
            ),
          },
        },
        inputRef: fieldRef,
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('RentalPortal.ApplicantFormHouseholdSizeLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={APPLICANT_FORM_FIELD_NAME_HOUSEHOLD_SIZE}
      options={toApplicantHouseholdSizeSelectItems({
        sizes: getMockApplicantHouseholdSizes(),
        t,
      })}
    />
  )
}

export default HouseholdSizeField
